import { createApiV2 } from "../common";

export const getViews = () => (token) =>
  createApiV2("GET", "dynamic_schema/user_custom_views/")(token);

export const postView = (payload) => (token) =>
  createApiV2("POST", "dynamic_schema/user_custom_views/")(token, payload);

export const patchView =
  ({ uid, payload }) =>
  (token) =>
    createApiV2("PATCH", `dynamic_schema/user_custom_views/${uid}/`)(token, payload);

export const deleteView = (uid) => (token) =>
  createApiV2("DELETE", `dynamic_schema/user_custom_views/${uid}/`)(token);

export default {};
